/**
 * Created by Jerker Nord on 2018-07-02.
 */
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BetWayWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {Timeline, TimelineLite} from "gsap";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";

export class IceIceYetiIndividualWPController extends BetWayWinIndividualWPController{

    private _yetiConfig:IIndividualWinPresentationConfig;

    constructor(config:IIndividualWinPresentationConfig, name:string = "BetWayIndividualWin", tweakEnabled?:boolean) {
        super(config, name, tweakEnabled);

        this._yetiConfig = config;
    }

    protected getLineAnimation(betWayWinData:IBetWayWinData):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        const reelsNum:number = betWayWinData.length;
        let currentDuration:number = 0;
        for(let i:number = 0; i < reelsNum; i++) {
            for(let j:number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                if(betWayWinData.reelWinPositions[i][j]) {
                    const symbol = Reels.getSymbol(i, j);
                    if(symbol) {
                        this.addSymbolWinAnimationToTimeline(betWayWinData, timeline, this._yetiConfig.symbolTimeOffsetCalculator(currentDuration, i, j), symbol, i, j);
                        this._winSymbols.push(symbol);
                    }
                }
            }
            currentDuration = timeline.totalDuration();
        }

        return timeline;
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        timeline.add(symbol.changeState({
            state : IceIceYetiGameConfig.instance.SYMBOL_STATES.win,
            fadeInDuration : 0.4
        }), startTime);
    }

    protected stopWinPresentation(isAbort:boolean):void {
        super.stopWinPresentation(isAbort);
    }
}